<div class="wrapper">
  <div class="center">
    <img src="/assets/computer-trouble.gif" alt="Computer Smashing GIF">
    <div class="header flex flex-column gap-3">
      <h1>yep, that's a <span class="accent-color">404</span></h1>
      <p>we've all seen this one before. "the page or resource could not be found" and all that jazz.</p>
    </div>

    <p-button routerLink="" outlined label="go to a page that exists"></p-button>
  </div>
</div>
